import { Component } from "@angular/core";

@Component({
    selector: "app-region-page",
    templateUrl: "./region-page.component.html",
    styleUrls: ["./region-page.component.scss"],
    standalone: false
})
export class RegionPageComponent {
    /**
     * Programmatically download the PDF located at assets/documents/Látnivalók.pdf
     * Uses fetch to get the blob and creates a temporary anchor to trigger the download
     * so the template doesn't need an <a> element.
     */
    downloadPdf(): void {
        try {
            const url = 'assets/documents/Látnivalók.pdf';
            const a = document.createElement('a');
            a.href = url;
            a.download = 'Látnivalók.pdf';
            a.click();
            a.remove();
        } catch (err) {
            console.error('PDF letöltési hiba', err);
        }
    }
}